import React from 'react'

const LegalOrderingDiv = ({ children }) => {
  return (
    <div
      style={{
        marginRight: 8,
      }}
    >
      {children}
    </div>
  )
}

export default LegalOrderingDiv
